// frontend/shared-ui/src/components/Alert.jsx
import React from "react";

export default function Alert({
  variant = "info",
  title,
  children,
  className = "",
}) {
  return (
    <div className={`fh-alert fh-alert--${variant} ${className}`} role="alert">
      <div className="fh-alert__content">
        {title && <div className="fh-alert__title">{title}</div>}
        {children}
      </div>
    </div>
  );
}
